<template>
  <FixedActionBar class="anytime-consultation-action-bar">
    <slot />
  </FixedActionBar>
</template>
<script>
import FixedActionBar from "@/vue/shared/ui/FixedActionBar.vue";
export default {
  name: "AnytimeConsultationActionBar",
  components: { FixedActionBar }
};
</script>
